import type { PdfSettings } from '@autobid/strapi-integration/typescript/strapi/Pdf'
import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

interface PdfDialog {
  id: string
  isOpen: boolean
  pdfUrl: string
}

export const usePdfStore = defineStore('usePdf', () => {
  const pdfSettings = ref<PdfSettings>({})
  const loadingSections = ref<Record<string, boolean>>({})
  const pdfDialogs = reactive<Record<string, PdfDialog>>({})
  /**
   * timeouts for pdf dialog stored as `{ [dialogId]: timeoutId }`
   */
  const timeouts = reactive<Record<string, NodeJS.Timeout>>({})

  const showPdfDialog = (name: string, pdfUrl: string) => {
    if (timeouts[name]) {
      clearTimeout(timeouts[name])
    }

    pdfDialogs[name] = {
      id: name,
      isOpen: true,
      pdfUrl,
    }
  }
  const closePdfDialog = (name: string) => {
    if (!pdfDialogs[name])
      return
    pdfDialogs[name].isOpen = false
    timeouts[name] = setTimeout(() => {
      delete pdfDialogs[name]
    }, 3000)
  }

  return {
    pdfSettings,
    loadingSections,
    showPdfDialog,
    closePdfDialog,
    pdfDialogs,
  }
})
